import React from "react"
import PropTypes from "prop-types"

import Header from './header';
import Footer from './footer';
import Cursor from './Cursor';
import Clients from './clients';
import MomentumScroll from './smooth-scroll';

import './../styles/base.scss';

const Layout = ({ children }) => {
  return (
    <main>
      <Header />
      <div id="layout-container">
        <MomentumScroll>
          {children}
          <Clients />
          <Footer />
        </MomentumScroll>
      </div>
      <Cursor />
    </main>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
